// extracted by mini-css-extract-plugin
module.exports = {"link":"_ForgotPasswordRichText_link__1Ryj1"};